// apps/web/src/components/docs/ApiDocs.tsx
// Developer documentation + API reference browser.

import { useState } from 'react';

const SECTIONS = [
  { id: 'auth', title: 'Authentication', body: 'OTP-first sign in, JWT access tokens, rotating refresh tokens.' },
  { id: 'otp', title: 'OTP', body: 'Generate and verify one-time passwords for contacts.' },
  { id: 'creators', title: 'Creators', body: 'Creator profiles, social accounts, rates, portfolio.' },
  { id: 'campaigns', title: 'Campaigns', body: 'Campaign CRUD, briefs, participants, deliverables, offers.' },
  { id: 'finance', title: 'Finance', body: 'Invoices, payments, settlements, tax.' },
  { id: 'content', title: 'Content', body: 'Content assets, reviews, rights, publishing.' },
  { id: 'webhooks', title: 'Webhooks', body: 'Subscribe, receive deliveries, retry failures.' },
  { id: 'api', title: 'API Reference', body: 'Every /api/v1 endpoint, grouped by resource.' },
];

export function ApiDocs() {
  const [active, setActive] = useState(SECTIONS[0]!.id);

  const section = SECTIONS.find((s) => s.id === active) ?? SECTIONS[0]!;

  return (
    <div className="docs-page">
      <div className="header">
        <h2>Developer Documentation</h2>
      </div>
      <div className="docs-layout">
        <aside className="docs-sidebar">
          {SECTIONS.map((s) => (
            <button
              key={s.id}
              type="button"
              className={`docs-link ${s.id === active ? 'active' : ''}`}
              onClick={() => setActive(s.id)}
            >
              {s.title}
            </button>
          ))}
        </aside>
        <article className="docs-body">
          <h3>{section.title}</h3>
          <p>{section.body}</p>
          <pre className="code-block">{`GET /api/v1/${section.id === 'api' ? '…' : section.id}`}</pre>
        </article>
      </div>
    </div>
  );
}